<div class="card card-nc enrollment">
  <div class="card-body">
    <div class="enrollHelpTitle"><p><b>New Members to the Navy Cash Program please continue through the enrollment steps to complete Navy Cash Account Setup.</b></p>
      <p><b>If you have previously enrolled in the Navy Cash Program do not enroll again.  Please call the Customer Service Center (CSC) to gain access to your account at 1-866-3NAVYCASH / 1-866-362-8922.</b></p>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-nc subEnroll">
          <div class="card-body enroll">
            <div class="enrollHelpTitle"><b>Benefits of Navy Cash</b></div>
            <br />
            <div class="enrollHelpTitle">
              <b>24/7 Account Access</b><br />
              Cashless ATMs aboard ship provide 24-hour a day, 7 day a week
              access to Navy Cash accounts. If you choose the Split Pay Option,
              you may designate a portion of your pay to be sent directly to
              your Navy Cash account each payday
            </div>
            <br />
            <div class="enrollHelpTitle">
              <b>Easy to Access Money</b><br />
              The magstrip and branded debit feature gives you access to your
              funds in your Navy Cash Account world-wide via Automated Teller
              Machines (ATMs) and point of sale (POS) devices at merchants who
              accept debit cards.
            </div>
            <br />
            <div class="enrollHelpTitle">
              <b>Easy to Move Money</b><br />
              The cashless ATMs also provide you with access to accounts at
              financial institutions ashore and the ability to move money
              electronically to and from Navy Cash accounts and your accounts at
              a financial institution
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-nc subEnroll">
          <div class="card-body enroll">
            <div class="enrollHelpTitle">
              <b>Who is Eligible?</b><br /><br />
              Navy Cash is available to anyone that is stationed or working at a
              Navy Cash installation which includes US Navy Surface warfare and
              USNS ships.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button
          id="enroll_button"
          type="button"
          class="btn btn-block pull-right"
          (click)="start()"
        >
          Enroll Now
        </button>
      </div>
    </div>
  </div>
</div>
